
import tables_title_zh from "./tables_title/tables_title_zh"
import elementZhLocale from 'element-ui/lib/locale/lang/zh-CN'

import user_management_zh from "./user_management/user_management_zh"
import role_management_zh from "./role_management/role_management_zh"
import dept_management_zh from "./dept_management/dept_management_zh"
import posts_management_zh from "./posts_management/posts_management_zh"
import dict_management_zh from "./dict_management/dict_management_zh"
import menu_management_zh from "./menu_management/menu_management_zh"
import notice_management_zh from "./notice_management/notice_management_zh"
import tenant_management_zh from "./tenant_management/tenant_management_zh"

const zh = {
  global:{
    home:'首页',
    system:'系统管理',
    users:'用户管理',
    roles:'角色管理',
    depts:'部门管理',
    posts:'职位管理',
    dict_type:'字典管理',
    menus:'菜单管理',
    login_log:'登录日志',
    business_log:'业务日志',
    messages:'通知管理',
    tenants:'租户管理',
    search:'搜索',
    add:'添加',
    create: '创建表单',
    back:'返回',
    export:'导出',
    importPatients:'导入患者',
    importTemplate:'导入模板',
    expand_all:'展开所有',
    clear_log:'清空日志',
    modify:'修改',
    delete:'删除',
    details:'详情',
    operation:'操作',
    submit:'提交',
    cancel:'取消',
    logout:'退出',
    confirm:'确认',
    look: '查看',
    change_password:'修改密码',
    old_password:'旧密码',
    new_password:'新密码',
    empty_old_pwd:'请输入旧密码',
    empty_new_pwd:'请输入新密码',
    modified_success:'修改成功',
    added_success:'添加成功',
    del_success:'删除成功',
    select_export:'请选择需要导出的数据',
    table_data_title:'数据表格',
    tips:'提示',
    empty_sort:'请输入排序',
    dev_tools:'开发管理',
    // questionnaire:'表单管理',
    questionnaire:'流调管理',
    create_scale:'创建量表',
    scale_manage: '量表管理',
    business_menu: '业务菜单',
    health_assessment_manage: '健康评估管理',
    questionnaire_survey_manage: '表单调查管理',
    model_manage: '模型管理',
    look_issue_msg: '查看发布信息',
    edit_relevance_scale: '编辑关联量表',
    look_relevance_scale: '查看关联量表',
    patient_manage: '患者管理',
    look_relevance_model: '查看关联模型',
    index_manage: '指标管理',
    edit: '编辑',
    reset: '重置',
    refresh: '刷新',
    edit_index: '编辑指标',
    go_back: '返回',
    look_model_fill_in_ed: '查看已填报模型',
    look_worked_scale: '查看已填报量表',
    look_report:'查看报告',
    look_data:'查看数据',
    look_index_report: '查看指标报告',
    evaluated_report:'已测评报告',
    project_manage: '项目管理',
    edit_relevance_model: '编辑关联模型',
    look_relevance_model: '查看关联模型',
    set_gross_score_index: '设置总分指标',
    label_manage: '标签管理',
    export_data: '导出数据',
    statistic_analysis: '统计分析',
    home_page: '首页',
    register:'注册',
    create_index: '创建指标',
    visual_create_index: '可视化创建指标',
    write_astrict: '填写限制',
    verify_index_var: '校验指标变量',
    set_evaluate_index: '设置评价指标',
    update_index_var_topic_title: '更新指标变量题目标题',
    evaluator_manage:'自评用户管理',
    view_document:'查看文档',
    import_scale:'导入量表',
    export_scale:'导出量表',
    questionnaire_manage:'流调管理',
    questionnaire_name:'表单名称',
    issue:'发布',
    answer:'答题',
    export_file:'导出附件',
    copy:'复制',
    selfcheck_scale_manage:'自评量表管理',
    assess_results_reporting:'查看评估结果报告',
    questionnaire_attribute: '表单属性',
    label_type_manage:'标签类型管理',
    add_child_type: "添加子标签",
    data_analysis:'数据分析',
    role_scale:'配置表单',
    assignment: '分配'
  },
  tables_title:tables_title_zh,
  ...elementZhLocale,
  user_management:user_management_zh,
  role_management:role_management_zh,
  dept_management:dept_management_zh,
  posts_management:posts_management_zh,
  dict_management:dict_management_zh,
  menu_management:menu_management_zh,
  notice_management:notice_management_zh,
  tenant_management:tenant_management_zh
}

export default zh



// WEBPACK FOOTER //
// ./src/common/lang/zh.js